import { Component, inject, OnInit } from '@angular/core';
import { ErrorPageComponent } from '@tribeauto/ngx-mobilite-material';
import { MatAnchor, MatButton } from '@angular/material/button';
import { Location } from '@angular/common';
import { ThemingService } from '../../theming/theming.service';
import { ThemingQueryParams } from '../../theming/theming.model';
import { TranslatePipe } from '@ngx-translate/core';

@Component({
  selector: 'fol-error',
  imports: [ErrorPageComponent, MatAnchor, MatButton, TranslatePipe],
  templateUrl: './error.component.html'
})
export class ErrorComponent implements OnInit {
  private readonly location = inject(Location);
  private readonly themingService = inject(ThemingService);
  additionalText = 'additional-text';

  back(): void {
    this.location.back();
  }

  ngOnInit(): void {
    this.themingService.getThemingJson(new ThemingQueryParams({ societyCode: 700 })).subscribe();
  }
}
